define('services/events/calendar-events',[
    // Libs
    'underscore', 'backbone', 'utils',
    // class
    'src/event-aggregator'

], function(
    // Libs
    _, Backbone, U,
    // class
    EventAggregator
) {

    var CalendarEvents = _.extend({}, EventAggregator.prototype, {
        itemUpdate: function(model) {
            this.trigger('item:update', model);
        },
        sessionUpdate: function(model, origin, duplicate) {
            this.trigger('session:update', model, origin, duplicate);
        },
        toggleDone: function(model, value) {
            this.trigger('toggle:done', model, value);
        },
        goalNewItemToggleDone: function(model, value) {
            this.trigger('goalNewItemToggle:done', model, value);
        },
        feedbackModalChange: function(model) {
            this.trigger('feedbackModal:change', model);
        },
        templateAssign: function() {
            this.trigger('template:assign');
        },
        itemDestroyed: function(id) {
            this.trigger('item:destroy', id);
        },
        sessionDestroyed: function(id) {
            this.trigger('session:destroy', id);
        },
        itemMove: function(model) {
            this.trigger('item:itemMove', model);
        },
        calendarRenderComplete: function() {
            this.trigger('calendar:renderComplete');
        },
        calendarRenderStart: function() {
            this.trigger('calendar:renderStart');
        },
        daysBeforeCalendarItemsAreHiddenChange: function() {
            this.trigger('calendar:daysBeforeCalendarItemsAreHiddenChange');
        },

        editActivity: function () {
            this.trigger('activity:edit');
        },

        onNewItemToday: function() {
            this.trigger('newItemToday');
        },

        onActivitySaveClick: function() {
            this.trigger('onActivitySaveClick');
        },

        onItemWeekChange: function(sessionId) {
            this.trigger('onItemWeekChange', sessionId);
        },

        removeNonEmptyWeek: function() {
            this.trigger('removeNonEmptyWeek');
        }
    });

    return CalendarEvents;

});

